import getGlobalFromWindow from '../../shared/helpers/getGlobalFromWindow';


export const isActiveNavItem = url => window.location.href.match(url);

export const isActiveNavFlyout = function isActiveNavFlyout(category) {
  const homeURL = `${getGlobalFromWindow('homeURL')}/`;
  const windowLocation = (window.location.origin + window.location.pathname).toString().toLowerCase();
  let activeSubgroups;

  const isHomePage = windowLocation === homeURL.toLowerCase();
  if (isHomePage) {
    return false;
  }

  if (category.subGroups && category.subGroups.length > 0) {
    activeSubgroups = filterNavSubgroups(category.subGroups, windowLocation);
  }

  return !!(activeSubgroups && activeSubgroups.length > 0);
};

const filterNavSubgroups = (subGroups, windowLocation) => {
  const activeItems = subGroups.filter((subGroup) => {
    const { items } = subGroup;

    return items.find(item => {
      const linkStart = item.indexOf('(') + 1;
      const linkEnd = Math.max(item.lastIndexOf('{'), 0) || item.length - 1;
      const link = item.substring(linkStart, linkEnd).toLowerCase();
      const linkLength = link.length;

      return linkLength >= windowLocation.length && windowLocation.substring(0, linkLength) === link;
    });
  });

  return activeItems;
};
